




















import { Component, Ref } from 'vue-property-decorator';
import Create from '@/layouts/Create';

import CreateBlock from '@/views/CRUD/Create.vue';
import TitleReturn from '@/components/TitleReturn.vue';
import FormView from './_form.vue';

import ResponseHandlerModule from '@/store/modules/responseHandler';
import AdministratorsModule from '@/store/administrators';
import AdministratorEntityModule from '@/store/administrators/entity';
import { AdministratorCard } from '@/types/models/administrators';
import UserModule, { RoleEnum } from '@/store/user';
import { validateAdministratorForm, prepareAdministratorData } from '@/utils/administrators';

type CalendarConsultationErrors = Partial<Record<keyof AdministratorCard, string>>;

@Component({
    components: {
        CreateBlock,
        TitleReturn,
        FormView,
    },
})
export default class DoctorsProfileAddPage extends Create {
    @Ref() $form!: FormView;

    errors: CalendarConsultationErrors = {};

    get readonly() {
        return UserModule.role !== RoleEnum.ROLE_SUPER_ADMIN;
    }

    validate(administrator: AdministratorCard): boolean {
        this.errors = validateAdministratorForm(administrator, true);
        const errorsCount = Object.keys(this.errors).length

        return errorsCount === 0;
    }

    triggerSave() {
        this.$form.triggerSave();
    }

    async create(administrator: AdministratorCard) {
        this.errors = {};

        const isValid = this.validate(administrator);

        if (!isValid) {
            return;
        }

        try {
            const data = prepareAdministratorData(administrator, true);
            const administratorsId = await AdministratorEntityModule.createNew(data);

            ResponseHandlerModule.showNotify({ message: 'Администратор добавлен', type: 'ok' });

            if (!administratorsId) {
                return;
            }

            this.$router.push({ name: 'administrators_edit', params: {
                administratorsId
            }});
        } catch (error: any) {
            const errors = error?.response?.data?.errors?.fields;
            const errorFields: Record<string, string> = errors;
            const allErrorMessages = Object.values(errorFields);

            const [ errorMessage ] = allErrorMessages;

            ResponseHandlerModule.showNotify({ message: errorMessage, type: 'fail' });
            this.errors = errorFields ?? {};
        }
    }

    returnBefore() {
        this.$router.push({ name: 'administrators' });
    }

    async created() {
        this.title = AdministratorsModule.pageSettings.titleAdd;
    }
}
